import { render, staticRenderFns } from "./clipboardBar.vue?vue&type=template&id=5fdfa65e"
import script from "./clipboardBar.vue?vue&type=script&lang=js"
export * from "./clipboardBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports